import React from "react";
import { useTranslation } from "react-i18next";
import "../i18n";
import "../assets/css/HeroSection.css";
import logo from "../assets/imgs/logo.png"

function HeroSection() {
  const { t, i18n } = useTranslation();

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    document.dir = lang === "ar" ? "rtl" : "ltr";
  };

  const scrollToNext = () => {
    const nextSection = document.getElementById("next-section");
    nextSection?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="hero-section">
      {/* Language Switch */}
      <div className="lang-switch">
        <button onClick={() => changeLanguage("en")}>EN</button>
        <button onClick={() => changeLanguage("ar")}>عربي</button>
      </div>

      {/* Centered Content */}
      <div className="hero-content">
        <img src={logo} alt="Kaak and Tea Logo" className="hero-logo" />
        <h1 className="hero-title">{t("title")}</h1>
        <p className="hero-subtitle">{t("sub-title")}</p>
        <button className="hero-btn" onClick={scrollToNext}>
          {t("saythanks", { defaultValue: "Say Thank You" })}
        </button>
      </div>
    </section>
  );
}

export default HeroSection;
